// import React, { Component } from "react";
// import CardContentHome from "../Card/CardContentHome";

// export default class ContentHome extends Component {
//   render() {
//     return (
//       <section class="new-content">
//         <div class="container">
//           <div class="row content-text mt-5 text-center">
//             <div class="col-12 px-md-0 my-auto">
//               <h5 class="tagline">Pilihan materi</h5>
//               <h1 class="headline mt-3">
//                 Beberapa pilihan <br class="d-none d-md-block" />
//                 materi rekomendasi kami
//               </h1>
//             </div>
//           </div>
//           <CardContentHome />
//           <div class="row">
//             <div class="text-center mt-4">
//               <a href="#" class="btn btn-primary me-2">
//                 See All Categories
//               </a>
//               <a href="#" class="btn btn-outline-warning">
//                 Need help?
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }
// }
import React, { Component } from "react";
import CardContentHome from "../Card/CardContentHome";

export default class ContentHome extends Component {
  render() {
    return (
      <section class="new-content">
        {/* <div class="container">
          <div class="row content-text mt-5 text-center">
            <div class="col-12 px-md-0 my-auto">
              <h5 class="tagline">Pilihan materi</h5>
              <h1 class="headline mt-3">
                Beberapa pilihan <br class="d-none d-md-block" />
                materi rekomendasi kami
              </h1>
            </div>
          </div>
          <CardContentHome />
          <div class="row">
            <div class="text-center mt-4">
              <a href="#" class="btn btn-primary me-2">
                See All Categories
              </a>
              <a href="#" class="btn btn-outline-warning">
                Need help?
              </a>
            </div>
          </div>
        </div> */}
      </section>
    );
  }
}